import { z } from "zod";

type FullName = {
  first: string;
  middle?: string;
  last: string;
};
namespace FullName {
  export const zodSchema = () =>
    z.object({ first: z.string(), last: z.string() });
  export const format = (name: FullName | undefined | null) =>
    !name
      ? ""
      : `${name.first} ${name.middle ? `${name.middle} ` : ""}${name.last}`;
}

export default FullName;
